import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  rootContainer: {
    width: "100%",
    height: "55px",
backgroundColor: "#354a5f",
    display: "flex",
    justifyContent: "space-around",
    overflow: "hidden",
  },
  tabsContainer: {
    marginTop: 4,
    textDecoration: "none",
  },
  text: {
    display: "block",
  },
  tabSelected: {
    color: "#7bcfff !important",
  },
  
    tabDisabled: {
    color: "#d1d1d1 !important",
  },

  "@media (max-width:570px)": {
    text: {
      display: "none",
    },
  },
}));
